import axiosInstance from '../utils/api';

const dashboardService = {
    fetchAmountData: async (params = null) => {
        try {
            const result = await axiosInstance.post('DashBoard/get-amount-related-data-for-external', params);
            return result?.data;
        }
        catch (error) {
            return error.response;
        }
    },
    fetchClaimDaysData: async (params = null) => {
        try {
            const result = await axiosInstance.post('DashBoard/get-claim-status-count-tracker-for-external', params);
            return result?.data;
        }
        catch (error) {
            return error.response;
        }
    }
};

export default dashboardService;
